import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import LoadingPage from "./LoadingPage";
import PageFive from "./PageFive";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import PageSix from "./PageSix";
import PageSeven from "./PageSeven";

const PageFour = ({ idJadwalCbt, idKelas, kodeTahunAjaran, schoolName }) => {
    const [fetching, setFetching] = useState(false);
    const [headerSurvey, SetHeaderSurvey] = useState([]);
    const [surveyKarakter, SetSurveyKarakter] = useState([]);
    const [dataSummary, SetDataSummary] = useState([]);
    const [dataMembudaya, SetDataMembudaya] = useState([]);
    const [dataBaik, SetDataBaik] = useState([]);
    const [dataBerkembang, SetDataBerkembang] = useState([]);
    const [openPage, setOpenPage] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_FOUR, {
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    kodeTahunAjaran: kodeTahunAjaran,
                })
                .catch(function (error) {
                    console.error("Error Response Page Two", error);
                });

            if (response) {
                if (response.data.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page Four ", responseAPI);
                    console.log("====================================");

                    SetHeaderSurvey(responseAPI.listHeader);
                    SetSurveyKarakter(responseAPI.listSurveyKarakter);
                    SetDataSummary(responseAPI.summary);
                    SetDataMembudaya(responseAPI.summary.membudaya);
                    SetDataBaik(responseAPI.summary.baik);
                    SetDataBerkembang(responseAPI.summary.berkembang);
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <div>
            <div className="report-page">
                <div className="header-second-page">
                    <GridInline width={"100%"}>
                        <GridInline width={"80%"}>
                            <LabelTitle label={"Hasil Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                            <LabelTitle label={schoolName} size={18} bolder={500} color={"#fff"} />
                        </GridInline>

                        <GridInline width={"20%"}>
                            <div
                                style={{
                                    border: "2px solid #fff",
                                    padding: 5,
                                    textAlign: "center",
                                    borderRadius: 10,
                                }}
                            >
                                <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                            </div>
                        </GridInline>
                    </GridInline>
                </div>
                <Gap height={20} />
                <div className="section-three">
                    <div className="result">
                        <GridInline width={"100%"}>
                            <GridInline width={"40%"}>
                                <LabelTitle label={"Rekapitulasi Survei Karakter :"} size={18} bolder={700} color={"#212529"} />
                                <LabelTitle label={"Berdasarkan Aspek Profil Pelajar Pancasila"} size={16} bolder={600} color={"#212529"} />
                            </GridInline>
                            <GridInline width={"60%"}>
                                <GridInline width={"100%"} marginTop={"5%"}>
                                    <GridInline width={"25%"}>
                                        <div
                                            style={{
                                                textAlign: "center",
                                            }}
                                        >
                                            <LabelTitle label={"Keterangan : "} size={14} bolder={600} color={"#6C757D"} />
                                        </div>
                                    </GridInline>
                                    <GridInline width={"25%"}>
                                        <div
                                            style={{
                                                textAlign: "center",
                                            }}
                                        >
                                            <GridInline width={"25%"}>
                                                <img src="/assets/image/like.png" width={25} />
                                            </GridInline>
                                            <GridInline>
                                                <LabelTitle label={"Membudaya"} size={14} bolder={600} color={"#6C757D"} />
                                            </GridInline>
                                        </div>
                                    </GridInline>
                                    <GridInline width={"25%"}>
                                        <div
                                            style={{
                                                textAlign: "center",
                                            }}
                                        >
                                            <GridInline width={"25%"}>
                                                <img src="/assets/image/ling-hijau.png" width={20} />
                                            </GridInline>
                                            <GridInline>
                                                <LabelTitle label={"Baik"} size={14} bolder={600} color={"#6C757D"} />
                                            </GridInline>
                                        </div>
                                    </GridInline>
                                    <GridInline width={"25%"}>
                                        <div
                                            style={{
                                                textAlign: "center",
                                            }}
                                        >
                                            <GridInline width={"25%"}>
                                                <img src="/assets/image/ling-colat.png" width={20} />
                                            </GridInline>
                                            <GridInline>
                                                <LabelTitle label={"Berkembang"} size={14} bolder={600} color={"#6C757D"} />
                                            </GridInline>
                                        </div>
                                    </GridInline>
                                </GridInline>
                            </GridInline>
                        </GridInline>
                        <Gap height={20} />
                        <div className="rekap-table">
                            <Table size="sm" style={{ fontSize: 14 }}>
                                <thead
                                    style={{
                                        backgroundColor: "#E9ECEF",
                                        fontSize: 15,
                                        textAlign: "center",
                                    }}
                                >
                                    <tr>
                                        <th width="10">No</th>
                                        <th
                                            height="50"
                                            style={{
                                                textAlign: "left",
                                            }}
                                        >
                                            Nama Siswa
                                        </th>
                                        {headerSurvey.map((dataHeader, i) => {
                                            return (
                                                <th key={i} width="130">
                                                    {dataHeader.aspek}
                                                </th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                {surveyKarakter.map((dataSurvey, j) => {
                                    return (
                                        <tr
                                            key={j}
                                            height="40"
                                            style={{
                                                backgroundColor: "#F8F9FA",
                                                textAlign: "center",
                                            }}
                                        >
                                            <td>{j + 1}</td>
                                            <td style={{ textAlign: "left" }}>{dataSurvey.namaSiswa}</td>
                                            {dataSurvey.listSurveyKarakterSiswa.map((dataSurveySiswa, k) => {
                                                return (
                                                    <td>
                                                        {dataSurveySiswa.kategori == "Unggul" ? (
                                                            <img src="/assets/image/like.png" width={25} />
                                                        ) : dataSurveySiswa.kategori == "Baik" ? (
                                                            <img src="/assets/image/ling-hijau.png" width={20} />
                                                        ) : (
                                                            <img src="/assets/image/ling-colat.png" width={20} />
                                                        )}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </Table>
                        </div>
                    </div>
                </div>
                <Gap height={40} />
                <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={dateTime} />
                </div>
            </div>

            <div className="report-page">
                <div className="header-second-page">
                    <GridInline width={"100%"}>
                        <GridInline width={"80%"}>
                            <LabelTitle label={"Hasil Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                            <LabelTitle label={"Nama Sekolah"} size={18} bolder={500} color={"#fff"} />
                        </GridInline>

                        <GridInline width={"20%"}>
                            <div
                                style={{
                                    border: "2px solid #fff",
                                    padding: 5,
                                    textAlign: "center",
                                    borderRadius: 10,
                                }}
                            >
                                <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                            </div>
                        </GridInline>
                    </GridInline>
                </div>
                <Gap height={20} />
                <div className="section-three">
                    <div className="result">
                        <LabelTitle label={"Summary Survei Karakter"} size={18} bolder={700} color={"#212529"} />
                        <LabelTitle label={"Profil Pelajar Pancasila"} size={16} bolder={600} color={"#212529"} />
                        <Gap height={20} />
                        <div className="rekap-table">
                            <GridInline width={"100%"} textAlign={"center"} backgroundColor={"#E9ECEF"} height={50}>
                                <GridInline width={"34%"} verticalAlign={"middle"} height={0}>
                                    <LabelTitle label={"Membudaya"} size={19} bolder={600} color={"#212529"} />
                                </GridInline>
                                <GridInline width={"33%"} verticalAlign={"middle"} height={0}>
                                    <LabelTitle label={"Baik"} size={19} bolder={600} color={"#212529"} />
                                </GridInline>
                                <GridInline width={"33%"} verticalAlign={"middle"} height={0}>
                                    <LabelTitle label={"Berkembang"} size={19} bolder={600} color={"#212529"} />
                                </GridInline>
                            </GridInline>
                            <GridInline width={"100%"} textAlign={"center"} height={"100%"}>
                                <GridInline width={"34%"} verticalAlign={"top"} height={0}>
                                    {dataMembudaya.map((summaryMembudaya, n) => {
                                        return (
                                            <GridInline width={"100%"} key={n} height={100}>
                                                <Gap height={10} />
                                                <img
                                                    src={"/assets/image/pemetaan/" + summaryMembudaya.tipe + ".png"}
                                                    width={40}
                                                    style={{
                                                        marginBottom: 5,
                                                        marginTop: 5,
                                                    }}
                                                />
                                                <LabelTitle label={summaryMembudaya.aspek} size={11} bolder={400} color={"#6C757D"} />
                                                <p
                                                    style={{
                                                        backgroundColor: "#0466C8",
                                                        color: "#fff",
                                                        borderRadius: 10,
                                                        padding: 2,
                                                        width: "25%",
                                                        fontSize: 13,
                                                        marginTop: 5,
                                                        textAlign: "center",
                                                        marginLeft: "38%",
                                                        marginBottom: 5,
                                                    }}
                                                >
                                                    Score : {summaryMembudaya.skor}
                                                </p>
                                            </GridInline>
                                        );
                                    })}
                                </GridInline>
                                <GridInline width={"33%"} verticalAlign={"top"} height={0}>
                                    {dataBaik.map((summaryBaik, n) => {
                                        return (
                                            <GridInline width={"100%"} key={n} height={100}>
                                                <Gap height={10} />
                                                <img
                                                    src={"/assets/image/pemetaan/" + summaryBaik.tipe + ".png"}
                                                    width={40}
                                                    style={{
                                                        marginBottom: 5,
                                                        marginTop: 5,
                                                    }}
                                                />
                                                <LabelTitle label={summaryBaik.aspek} size={11} bolder={400} color={"#6C757D"} />
                                                <p
                                                    style={{
                                                        backgroundColor: "#008000",
                                                        color: "#fff",
                                                        borderRadius: 10,
                                                        padding: 2,
                                                        width: "25%",
                                                        fontSize: 13,
                                                        marginTop: 5,
                                                        textAlign: "center",
                                                        marginLeft: "38%",
                                                        marginBottom: 5,
                                                    }}
                                                >
                                                    Score : {summaryBaik.skor}
                                                </p>
                                            </GridInline>
                                        );
                                    })}
                                </GridInline>
                                <GridInline width={"33%"} verticalAlign={"top"} height={0}>
                                    {dataBerkembang.map((summaryBerkembang, n) => {
                                        return (
                                            <GridInline width={"100%"} key={n} height={100}>
                                                <Gap height={10} />
                                                <img
                                                    src={"/assets/image/pemetaan/" + summaryBerkembang.tipe + ".png"}
                                                    width={40}
                                                    style={{
                                                        marginBottom: 5,
                                                        marginTop: 5,
                                                    }}
                                                />
                                                <LabelTitle label={summaryBerkembang.aspek} size={11} bolder={400} color={"#6C757D"} />
                                                <p
                                                    style={{
                                                        backgroundColor: "#FB8500",
                                                        color: "#fff",
                                                        borderRadius: 10,
                                                        padding: 2,
                                                        width: "25%",
                                                        fontSize: 13,
                                                        marginTop: 5,
                                                        textAlign: "center",
                                                        marginLeft: "38%",
                                                        marginBottom: 5,
                                                    }}
                                                >
                                                    Score : {summaryBerkembang.skor}
                                                </p>
                                            </GridInline>
                                        );
                                    })}
                                </GridInline>
                            </GridInline>
                        </div>
                    </div>
                </div>
                {/* <Gap height={540} />
                <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={dateTime} />
                </div> */}
            </div>

            {openPage ? <PageSeven idJadwalCbt={idJadwalCbt} idKelas={idKelas} kodeTahunAjaran={kodeTahunAjaran} schoolName={schoolName} /> : <LoadingPage />}
        </div>
    );
};

export default PageFour;
